import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serveEvaluateTypeVoList, handleServeEvaluate } from "@/api/serveCenter/serveCenter";
import { serveFileUpload, serveFileDelete } from "@/api/managementCenter/otherApi";
export default {
  name: "evaluateDialog",
  components: {},
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      show: false,
      loading: false,
      typeVoList: [],
      checkedTypeArr: [],
      filelist: [],
      form: {
        score: 5,
        content: "",
        privateFlag: 1,
        rationTypeIds: [],
        serveId: "",
        attach: ""
      },
      rules: {
        privateFlag: [{
          required: true,
          message: "请选择公开状态",
          trigger: "change"
        }],
        score: [{
          required: true,
          message: "请选择服务满意度",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    beforeRemove: function beforeRemove(file) {
      var _this = this;

      if (!file.id) {
        return;
      }

      this.deleteFile(file.id, function () {
        _this.filelist = _this.filelist.filter(function (i) {
          return file.id != i.id;
        });
      });
    },
    deleteFile: function deleteFile(id, callback) {
      var _this2 = this;

      serveFileDelete(id).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          callback && callback();

          _this2.$message.success("删除成功!");
        } else {
          _this2.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function (err) {
        _this2.$message.error("删除异常!");
      });
    },
    // 上传文件之前的方法
    beforeUpload: function beforeUpload(file) {
      var _this3 = this;

      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }

      var fd = new FormData();
      fd.append("fromTarget", 0);
      fd.append("file", file); //上传到后台

      this.loading = true;
      serveFileUpload(fd).then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("上传文件成功!");

          _this3.filelist.push(_objectSpread(_objectSpread({}, data.data), {}, {
            name: data.data.fileName
          }));
        } else {
          _this3.$message.warning(data.msg || "上传文件失败!");
        }
      }).catch(function (err) {
        _this3.loading = false;

        _this3.$message.error("上传文件异常!");
      });
    },
    // 获取评价查询列表
    getServeEvaluateTypeVoList: function getServeEvaluateTypeVoList(val, flag) {
      var _this4 = this;

      this.typeVoList = [];
      serveEvaluateTypeVoList({
        score: val + ""
      }).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this4.typeVoList = data.data || [];
          _this4.checkedTypeArr = [];

          if (flag) {
            _this4.checkedTypeArr = _this4.typeVoList.map(function (i) {
              return i.id;
            });
          }
        }
      }).catch(function () {});
    },
    rateChange: function rateChange(val) {
      this.getServeEvaluateTypeVoList(val);
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this5 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.submitServeEvaluate();
        } else {
          return false;
        }
      });
    },
    submitServeEvaluate: function submitServeEvaluate() {
      var _this6 = this;

      this.loading = true;
      handleServeEvaluate(this.form).then(function (_ref4) {
        var data = _ref4.data;
        _this6.loading = false;

        if (data.code == 0) {
          _this6.$message.success("评价成功!");

          _this6.$emit("saveSuccess");

          _this6.show = false;
        } else {
          _this6.$message.warning(data.msg || "评价失败!");
        }
      }).catch(function (err) {
        _this6.$message.error(err && err.message || "服务器异常!");

        _this6.loading = false;
      });
    },
    // 显示弹框
    dialogShow: function dialogShow(serveId) {
      this.show = true;
      this.form.serveId = serveId;
      this.form.score = 5;
      this.getServeEvaluateTypeVoList(5, true);
    }
  },
  watch: {
    filelist: function filelist(arr) {
      if (arr.length) {
        this.form.attach = arr[0].id;
      } else {
        this.form.attach = "";
      }
    },
    checkedTypeArr: function checkedTypeArr(val) {
      this.form.rationTypeIds = val;
    },
    show: function show(val) {
      if (!val) {
        this.form.answer = "";
        this.checkedTypeArr = [];
        this.filelist = [];
        this.form = {
          score: 5,
          content: "",
          privateFlag: 1,
          rationTypeIds: [],
          serveId: "",
          attach: ""
        };
      }
    }
  },
  filters: {}
};